/* eslint-disable no-nested-ternary */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Grid, TextInput, Button, Tooltip, Checkbox, Switch } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import { isInjuredOptions } from './ComponentsOptions';
import CustomAddPassengerSettingsForm from './CustomAddPassenger.settingsForm';
import './CustomAddPassenger.scss';
import AutocompleteDMTI from '../utils/AutocompleteDMTI/AutocompleteDMTI';
import getLocalParams from '../localizationCustoms';

class CustomAddPassenger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      // eslint-disable-next-line react/no-unused-state
      data: props.data,
      formValues: [],
      formErrors: {},
      isInjuryProvince: false,
      firstPassengerAdded: false,
      showErrorPhoneNumber: false,
    };

    this.setCheckboxValue = this.setCheckboxValue.bind(this);
    this.setToggleValue = this.setToggleValue.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.checked = this.checked.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
  }

  componentDidMount() {
    const { value, data } = this.state || null;
    const { component: { isAbOnlyClaim }, onChange } = this.props || false;
    const policyInfo = JSON.parse(window.sessionStorage.getItem('thePolicy'));
    const province = policyInfo?.policyProvince || null;
    const isInjuryProvince = province === 'Ontario' || province === 'Alberta' || province === 'New Brunswick' || province === 'Nova Scotia' || province === 'Prince Edward Island';
    if (typeof value === 'undefined' || value === null) {
      if (policyInfo?.drivers && policyInfo.drivers.length) {
        let driversInfo = policyInfo.drivers.map((driver, index) => ({ policySystemId: driver.policySystemId, id: '', temporaryId: `${driver.firstName}_${driver.lastName}_${Math.round(Math.random() * 0xFFFFFFFFFF).toString(16)}`, name: { value: `${driver.firstName} ${driver.lastName}`, review: { label: `Person ${index + 1}`, toReview: false } }, firstName: driver.firstName, lastName: driver.lastName, selected: false, isInjured: { value: isAbOnlyClaim, review: { label: 'Injured', toReview: false } } }));

        if (data?.whoDrivingVehicle?.value?.name !== 'Unoccupied' && data?.whoDrivingVehicle?.value?.name !== 'Driver not listed' && data?.whoDrivingVehicle?.value?.policySystemId) {
          driversInfo = driversInfo.filter((d) => d.policySystemId !== data.whoDrivingVehicle.value.policySystemId);
        }
        if (policyInfo?.insured && Object.keys(policyInfo.insured).length && data?.whoDrivingVehicle?.value?.policySystemId !== policyInfo?.insured?.policySystemId) {
          const { insured } = policyInfo;
          const insuredInfo = { policySystemId: insured.policySystemId, id: '', temporaryId: `${insured.firstName}_${insured.lastName}_${Math.round(Math.random() * 0xFFFFFFFFFF).toString(16)}`, name: { value: `${insured.firstName} ${insured.lastName}`, review: { label: `Person ${1} on policy`, toReview: false } }, firstName: insured.firstName, lastName: insured.lastName, selected: false, isInjured: { value: isAbOnlyClaim, review: { label: 'Injured', toReview: false } } };
          driversInfo = driversInfo.filter((d) => d.policySystemId !== insured.policySystemId);
          driversInfo.unshift(insuredInfo);
        }

        if (!isAbOnlyClaim) {
          this.setState({ value: { addPassengerInfo: [...driversInfo, { temporaryId: `No_Passenger_${Math.round(Math.random() * 0xFFFFFFFF).toString(16)}`, name: { value: 'No passenger', review: { label: 'Person', toReview: false } }, firstName: '', lastName: '', number: '', address: { value: '', addressObj: {} }, selected: false, isInjured: { value: isAbOnlyClaim, review: { label: 'Injured', toReview: false } } }] }, isInjuryProvince });
        } else {
          this.setState({ value: { addPassengerInfo: [...driversInfo] }, isInjuryProvince }, () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          });
        }
      } else if (!isAbOnlyClaim) {
        this.setState({ value: { addPassengerInfo: [{ temporaryId: `No_Passenger_${Math.round(Math.random() * 0xFFFFFFFF).toString(16)}`, name: { value: 'No passenger', review: { label: 'Person', toReview: false } }, firstName: '', lastName: '', number: '', address: { value: '', addressObj: {} }, selected: false, isInjured: { value: isAbOnlyClaim, review: { label: 'Injured', toReview: false } } }] }, isInjuryProvince }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else {
        this.setState({ value: { addPassengerInfo: [] }, isInjuryProvince }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    } else if (policyInfo?.drivers && policyInfo.drivers.length && !isAbOnlyClaim) {
      let driversInfo = policyInfo.drivers.map((driver, index) => ({ policySystemId: driver.policySystemId, id: '', temporaryId: `${driver.firstName}_${driver.lastName}_${Math.round(Math.random() * 0xFFFFFFFFFF).toString(16)}`, name: { value: `${driver.firstName} ${driver.lastName}`, review: { label: `Person ${index + 1}`, toReview: false } }, firstName: driver.firstName, lastName: driver.lastName, selected: false, isInjured: { value: isAbOnlyClaim, review: { label: 'Injured', toReview: false } } }));

      if (data?.whoDrivingVehicle?.value?.name !== 'Unoccupied' && data?.whoDrivingVehicle?.value?.name !== 'Driver not listed' && data?.whoDrivingVehicle?.value?.policySystemId) {
        driversInfo = driversInfo.filter((d) => d.policySystemId !== data.whoDrivingVehicle.value.policySystemId);
      }

      this.setState((prevState) => {
        let tempAddPassengerInfo = [...prevState.value.addPassengerInfo];

        const missingDrivers = driversInfo.filter((d) => {
          if (tempAddPassengerInfo.some((el) => el.policySystemId === d.policySystemId)) {
            return false;
          }
          return true;
        }).map((t) => ({ ...t, id: '', temporaryId: `tempId-${Math.round(Math.random() * 0xFFFFFFFFFF).toString(16)}` }));

        tempAddPassengerInfo = tempAddPassengerInfo.filter((d) => {
          if (Object.prototype.hasOwnProperty.call(d, 'policySystemId') && (d.policySystemId === data?.whoDrivingVehicle?.value?.policySystemId)) {
            return false;
          }
          return true;
        });

        return {
          value: { addPassengerInfo: [...missingDrivers, ...tempAddPassengerInfo] }, isInjuryProvince };
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  }

  handleChange(inputValue, index, name) {
    const { formValues, formErrors } = this.state;
    const regexp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

    if (name === 'isInjured') {
      formValues[index][name].value = inputValue;
      this.setState({ formValues });
    } else if (name === 'address') {
      formValues[index][name] = inputValue;
      this.setState({ formValues });
    } else if (name === 'number') {
      formValues[index][name] = inputValue;
      if (inputValue.trim() !== '' && (!regexp.test(inputValue) || inputValue[1] === '1')) {
        this.setState((prevState) => ({
          formValues,
          formErrors: {
            ...prevState.formErrors,
            number: inputValue[1] === '1' ? 'Oops! An area code cannot start with 1.' : 'Sorry! Your phone number must be 10 digits.',
          },
        }));
      } else if (Object.prototype.hasOwnProperty.call(formErrors, 'number')) {
        const newFormErrorsObj = { ...formErrors };
        delete newFormErrorsObj.number;
        this.setState({ formValues, formErrors: newFormErrorsObj });
      }
    } else {
      formValues[index][name] = inputValue;
      if (inputValue.trim() === '') {
        this.setState((prevState) => ({
          formValues,
          formErrors: {
            ...prevState.formErrors,
            [name]: 'Oops! Looks like you forgot to fill this in.',
          },
        }));
      } else if (Object.prototype.hasOwnProperty.call(formErrors, name)) {
        const newFormErrorsObj = { ...formErrors };
        delete newFormErrorsObj[name];
        this.setState({ formValues, formErrors: newFormErrorsObj });
      }
    }
  }

  handleValidation() {
    const regexp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    const { formValues, formErrors } = this.state;
    let isValid = true;

    if (formValues[0].firstName.trim() === '') {
      this.setState((prevState) => ({
        formErrors: {
          ...prevState.formErrors,
          firstName: 'Oops! Looks like you forgot to fill this in.',
        },
      }));
      isValid = false;
    } else if (Object.prototype.hasOwnProperty.call(formErrors, 'firstName')) {
      const newFormErrorsObj = { ...formErrors };
      delete newFormErrorsObj.firstName;
      this.setState({ formErrors: newFormErrorsObj });
    }

    if (formValues[0].lastName.trim() === '') {
      this.setState((prevState) => ({
        formErrors: {
          ...prevState.formErrors,
          lastName: 'Oops! Looks like you forgot to fill this in.',
        },
      }));
      isValid = false;
    } else if (Object.prototype.hasOwnProperty.call(formErrors, 'lastName')) {
      const newFormErrorsObj = { ...formErrors };
      delete newFormErrorsObj.lastName;
      this.setState({ formErrors: newFormErrorsObj });
    }

    if (formValues[0].number.trim() !== '' && (!regexp.test(formValues[0].number) || formValues[0].number[1] === '1')) {
      this.setState((prevState) => ({
        formErrors: {
          ...prevState.formErrors,
          number: formValues[0].number[1] === '1' ? 'Oops! An area code cannot start with 1.' : 'Sorry! Your phone number must be 10 digits.',
        },
      }));
      isValid = false;
    } else if (Object.prototype.hasOwnProperty.call(formErrors, 'number')) {
      const newFormErrorsObj = { ...formErrors };
      delete newFormErrorsObj.number;
      this.setState({ formErrors: newFormErrorsObj });
    }

    return isValid;
  }

  setToggleValue = (temporaryId, v) => {
    const { value, isInjuryProvince } = this.state;
    const { onChange, component: { isAbOnlyClaim } } = this.props;
    const updatedList = value.addPassengerInfo.map((val) => {
      if (val.temporaryId === temporaryId) {
        return { ...val, isInjured: { value: v, review: { label: 'Injured', toReview: val.selected && isInjuryProvince && !isAbOnlyClaim } } };
      }
      return val;
    });

    this.setState({
      value: { addPassengerInfo: updatedList },
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  setCheckboxValue = (checkboxValue, temporaryId) => {
    const { value, isInjuryProvince } = this.state;
    const { onChange, component: { isAbOnlyClaim }, intl } = this.props;
    let isSelected = false;
    if (value && value.addPassengerInfo) {
      if (value.addPassengerInfo.some((element) => element.name && element.name.value === checkboxValue)) {
        const updatedList = value.addPassengerInfo.map((v) => {
          if (v.temporaryId === temporaryId) {
            isSelected = !v.selected;
            return { ...v, selected: isSelected, name: { value: checkboxValue, review: { label: v.name.review.label, toReview: isSelected } }, isInjured: { value: isAbOnlyClaim || null, review: { label: 'Injured', toReview: (isSelected && isInjuryProvince && !isAbOnlyClaim && v.name.value !== 'No passenger') } } };
          } if (v.name.value === 'No passenger' && isSelected) {
            return { ...v, selected: false, name: { value: 'No passenger', review: { label: 'Person', toReview: false } }, isInjured: { value: isAbOnlyClaim || null, review: { label: 'Injured', toReview: false } } };
          }
          return v;
        });
        this.setState({
          value: { addPassengerInfo: updatedList },
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else {
        this.setState((prevState) => ({
          value: { addPassengerInfo: [...prevState.value, { name: { value: checkboxValue, review: { label: prevState.name.review.label, toReview: false } }, selected: false, isInjured: { value: isAbOnlyClaim || false, review: { label: 'Injured', toReview: false } } }] },
        }), () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    }

    this.setState((prevState) => {
      let count = 1;
      const newPassengerValues = [...prevState.value.addPassengerInfo];
      newPassengerValues.forEach((passenger) => {
        if (passenger.selected && passenger.name.value !== 'No passenger') {
          passenger.name.review.label = intl.formatMessage({ id: 'Person {count} on policy', defaultValue: `Person ${count} on policy` }, { count: `${count}` });
          count += 1;
        }
      });
      return {
        value: { addPassengerInfo: newPassengerValues },
        formValues: [],
        formErrors: {},
      };
    // eslint-disable-next-line react/destructuring-assignment
    }, () => { onChange(this.state.value); });
  };

  checked = (temporaryId) => {
    const { value } = this.state;
    if (value && value.addPassengerInfo) {
      return value.addPassengerInfo.find((v) => v.temporaryId === temporaryId).selected;
    }
    return false;
  };

  translateOptions = (options) => {
    const { intl } = this.props;
    return options.map((opt) => ({
      id: opt.id,
      value: opt.value,
      label: intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }),
    }));
  };

  addFormFields() {
    const { state: { value }, props: { component: { isAbOnlyClaim }, onChange } } = this;

    this.setState((prevState) => {
      const tempAddPassengerInfo = [...value.addPassengerInfo];

      if (prevState.formValues.length) {
        return {
          value: { addPassengerInfo: tempAddPassengerInfo, openForm: true },
          formValues: [...prevState.formValues, { firstName: '', lastName: '', number: '', address: { value: '', addressObj: {} }, isInjured: { value: isAbOnlyClaim, review: { label: 'Person', toReview: false } } }],
        };
      }
      return {
        value: { addPassengerInfo: tempAddPassengerInfo, openForm: true },
        formValues: [{ firstName: '', lastName: '', number: '', address: { value: '', addressObj: {} }, isInjured: { value: isAbOnlyClaim || null, review: { label: 'Person', toReview: false } } }],
      };

    // eslint-disable-next-line react/destructuring-assignment
    }, () => { onChange(this.state.value); });
  }

  removeFormFields() {
    const { state: { formValues, value }, props: { onChange } } = this;
    const newFormValues = formValues.pop();
    this.setState(() => {
      const tempAddPassengerInfo = [...value.addPassengerInfo];

      return {
        value: { addPassengerInfo: tempAddPassengerInfo },
        formValues: newFormValues,
      };
    // eslint-disable-next-line react/destructuring-assignment
    }, () => { onChange(this.state.value); });
  }

  confirmPassengers() {
    const { formValues, isInjuryProvince } = this.state;
    const { onChange, component: { isAbOnlyClaim }, intl } = this.props;

    if (this.handleValidation()) {
      const tranformedValues = formValues.map((v) => ({ temporaryId: `${v.firstName}_${v.lastName}_${Math.round(Math.random() * 0xFFFFFFFFFF).toString(16)}`, id: '', name: { value: `${v.firstName} ${v.lastName}`, review: { label: `Person ${0}`, toReview: true } }, firstName: v.firstName, lastName: v.lastName, number: v.number, address: { value: v.address.value, addressObj: v.address.addressObj }, selected: true, isInjured: { value: v.isInjured.value, review: { label: 'Injured', toReview: isInjuryProvince && !isAbOnlyClaim } } }));

      this.setState((prevState) => {
        const newPassengerValues = [...prevState.value.addPassengerInfo];
        tranformedValues.forEach((tv, index) => {
          newPassengerValues.splice(prevState.value.addPassengerInfo.length - 1 + index, 0, tv);
        });

        let count = 1;
        newPassengerValues.forEach((passenger) => {
          if (passenger.selected && passenger.name.value !== 'No passenger') {
            passenger.name.review.label = intl.formatMessage({ id: 'Person {count} on policy', defaultValue: `Person ${count} on policy` }, { count: `${count}` });
            count += 1;
          }
        });
        return {
          value: { addPassengerInfo: newPassengerValues },
          firstPassengerAdded: !prevState.firstPassengerAdded ? !prevState.firstPassengerAdded : prevState.firstPassengerAdded,
          formValues: [],
          formErrors: {},
          showErrorPhoneNumber: false,
        };
      // eslint-disable-next-line react/destructuring-assignment
      }, () => { onChange(this.state.value); });
    } else {
      this.setState(
        () => ({
          showErrorPhoneNumber: true,
        }),
        // eslint-disable-next-line react/destructuring-assignment
        () => { onChange(this.state.value); },
      );
    }
  }

  render() {
    const { state: { value, formValues, formErrors, firstPassengerAdded, isInjuryProvince, showErrorPhoneNumber }, props: { component: { hideCustomLabel, label, tooltip, customDescription, addPassengerButtonLabel, addAnotherPassengerButtonLabel, addPersonTitle, confirmLabel, isAbOnlyClaim }, disabled, intl, localParams } } = this;

    return (
      <div className="addPassengerContainer">
        <Grid>
          {!hideCustomLabel && (
          <div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label>
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
                <Tooltip id="addpassenger_tooltip" primary>
                  <FormattedMessage id={tooltip} defaultMessage={tooltip} />
                </Tooltip>
              )}
            </div>
            <p className="addPassengerMainTitle">
              <FormattedMessage id={customDescription} defaultMessage={customDescription} />
            </p>
          </div>
          )}
          {value && value.addPassengerInfo.length ? value.addPassengerInfo.map((checkbox, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${index}_${checkbox.name.value}`}>
              {checkbox.name && checkbox.name.value !== 'No passenger' ? (
                <div className="fs-exclude">
                  <Checkbox
                    primary
                    disabled={disabled}
                    style={{ margin: '0px', padding: '0px' }}
                    name="check"
                    id={checkbox.temporaryId}
                    key={`key_${checkbox.temporaryId}`}
                    value={checkbox.name.value}
                    onChange={(newValue) => this.setCheckboxValue(newValue, checkbox.temporaryId)}
                    checked={this.checked(checkbox.temporaryId)}
                  >
                    {checkbox.name.value}
                  </Checkbox>
                </div>
              ) : null}
              {checkbox.name && checkbox.name.value === 'No passenger' && !value.addPassengerInfo.some((element) => element.selected === true && element.name && element.name.value !== 'No passenger') ? (
                <div>
                  <Checkbox
                    primary
                    disabled={disabled}
                    style={{ margin: '0px', padding: '0px' }}
                    name="check"
                    id={checkbox.temporaryId}
                    key={`key_${checkbox.temporaryId}`}
                    value={checkbox.name.value}
                    onChange={(newValue) => this.setCheckboxValue(newValue, checkbox.temporaryId)}
                    checked={this.checked(checkbox.temporaryId)}
                  >
                    <FormattedMessage id={checkbox.name.value} defaultMessage={checkbox.name.value} />
                  </Checkbox>
                </div>
              ) : null}
              {this.checked(checkbox.temporaryId) && checkbox.name && checkbox.name.value !== 'No passenger' && !isAbOnlyClaim && isInjuryProvince ? (
                <div>
                  <Switch
                    name={`toggle_${checkbox.temporaryId}`}
                    disabled={disabled}
                    value={value?.addPassengerInfo?.find((v) => v.temporaryId === checkbox.temporaryId).isInjured.value}
                    options={this.translateOptions(isInjuredOptions)}
                    onChange={(v) => this.setToggleValue(checkbox.temporaryId, v)}
                  />
                </div>
              ) : null}
            </div>
          )) : null}
          {formValues.length
            ? (
              <div>
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center' }} className="question-margin-label question-margin-xsmall">
                  <p className="addPassengerTitle"> <FormattedMessage id={addPersonTitle} defaultMessage={addPersonTitle} /> </p>
                  <button
                    type="button"
                    className="removeAddPassengerButton"
                    onClick={() => this.removeFormFields()}
                  >
                    <FormattedMessage id="Remove" defaultMessage="Remove" />
                  </button>
                </div>
              </div>
            ) : null}
          {formValues.length ? formValues.map((element, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid key={index}>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    name="firstName"
                    className="question-margin-xsmall fs-exclude"
                    placeholder={intl.formatMessage({ id: 'First name', defaultValue: 'First name' })}
                    value={element.firstName || ''}
                    onChange={(v) => this.handleChange(v, index, 'firstName')}
                    maxLength={60}
                  />
                  {Object.prototype.hasOwnProperty.call(formErrors, 'firstName') ? (
                    <span className="formErrorMessage">
                      <FormattedMessage id={formErrors.firstName} defaultMessage={formErrors.firstName} />
                    </span>
                  ) : null}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    name="lastName"
                    className="question-margin-xsmall fs-exclude"
                    placeholder={intl.formatMessage({ id: 'Last name', defaultValue: 'Last name' })}
                    value={element.lastName || ''}
                    onChange={(v) => this.handleChange(v, index, 'lastName')}
                    maxLength={60}
                  />
                  {Object.prototype.hasOwnProperty.call(formErrors, 'lastName') ? (
                    <span className="formErrorMessage">
                      <FormattedMessage id={formErrors.lastName} defaultMessage={formErrors.lastName} />
                    </span>
                  ) : null}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    name="number"
                    className="question-margin-xsmall fs-exclude"
                    mask="(999) 999-9999"
                    placeholder={intl.formatMessage({ id: 'Phone number (optional)', defaultValue: 'Phone number (optional)' })}
                    value={element.number || ''}
                    onChange={(v) => this.handleChange(v, index, 'number')}
                    maxLength={30}
                  />
                  {Object.prototype.hasOwnProperty.call(formErrors, 'number') && showErrorPhoneNumber ? (
                    <span className="formErrorMessage">
                      <FormattedMessage id={formErrors.number} defaultMessage={formErrors.number} />
                    </span>
                  ) : null}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  <AutocompleteDMTI
                    index={index}
                    showErrorHandling
                    localParams={localParams}
                    className="question-margin-xsmall fs-exclude"
                    disabled={disabled}
                    name="address"
                    placeholder={intl.formatMessage({ id: 'Address (optional)', defaultValue: 'Address (optional)' })}
                    value={element.address || { value: '', addressObj: {} }}
                    handleChange={this.handleChange}
                  />
                </Grid.Column>
              </Grid.Row>
              {!isAbOnlyClaim && isInjuryProvince ? (
                <div style={{ marginTop: '20px' }}>
                  <Switch
                    disabled={disabled}
                    value={formValues[index]?.isInjured?.value}
                    options={this.translateOptions(isInjuredOptions)}
                    name={`toggle_${Math.random() * 0xffffff}`}
                    onChange={(v) => this.handleChange(v, index, 'isInjured')}
                  />
                </div>
              ) : null}
            </Grid>
          )) : null}
          <div>
            {!formValues.length ? (
              !firstPassengerAdded
                ? (
                  <div>
                    <button
                      type="button"
                      className="addPassengerButton"
                      onClick={() => this.addFormFields()}
                    ><FormattedMessage id={addPassengerButtonLabel} defaultMessage={addPassengerButtonLabel} />
                    </button>
                  </div>
                )
                : (
                  <div>
                    <button
                      type="button"
                      className="addPassengerButton"
                      onClick={() => this.addFormFields()}
                    ><FormattedMessage id={addAnotherPassengerButtonLabel} defaultMessage={addAnotherPassengerButtonLabel} />
                    </button>
                  </div>
                )
            ) : null}
            {formValues.length ? (
              <div className="confirm-passenger-bnt">
                <Button secondary underline onClick={() => this.confirmPassengers()}>
                  <FormattedMessage id={confirmLabel} defaultMessage={confirmLabel} />
                </Button>
              </div>
            ) : null}
          </div>
        </Grid>
      </div>
    );
  }
}

const CustomAddPassengerWithIntl = injectIntl(CustomAddPassenger);

export default class AddPassengerComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'CustomAddPassenger',
      icon: 'th',
      group: 'data',
      weight: 50,
      schema: AddPassengerComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
              */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customaddpassenger',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomAddPassengerSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */

  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomAddPassengerWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          localParams={localParams}
          data={this.data}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
